var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkedIn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M16.65,0H1.35A1.35,1.35,0,0,0,0,1.35v15.3A1.35,1.35,0,0,0,1.35,18h15.3A1.35,1.35,0,0,0,18,16.65V1.35A1.35,1.35,0,0,0,16.65,0M5.4,15.3H2.7V7.2H5.4ZM4.05,5.625A1.575,1.575,0,1,1,5.67,4.05,1.6,1.6,0,0,1,4.05,5.625M15.3,15.3H12.6V11.034c0-1.278-.54-1.737-1.242-1.737A1.567,1.567,0,0,0,9.9,10.964v.007a.59.59,0,0,0,0,.126v4.2H7.2V7.2H9.81V8.37a2.8,2.8,0,0,1,2.43-1.26c1.395,0,3.024.774,3.024,3.294Z",
    fill: "#0a66c2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedIn.7cabddac.svg";
export { ForwardRef as ReactComponent };